import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatDividerModule } from '@angular/material/divider'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TeamComponent } from '@app/features/scope-overview/components/team/team.component'
import { DeliverableBuilderComponent } from '@app/features/scoping/components/deliverable-builder/deliverable-builder.component'
import { FindReplaceComponent } from '@app/shared/components/find-replace/find-replace.component'
import { OutputEditorComponent } from '@app/shared/components/output-editor/output-editor.component'
import { DetailsOverviewComponent } from '@app/shared/components/ui-components/details-overview/details-overview/details-overview.component'
import { ScopeUiAutocompleteComponent } from '@app/shared/components/ui-components/scope-ui-autocomplete/scope-ui-autocomplete.component'
import { CKEditorModule } from '@ckeditor/ckeditor5-angular'
import { ScopeUiOptionsMenuComponent } from '@shared/components/scope-ui-options-menu/scope-ui-options-menu.component'
import { ScopeUiSnackbarComponent } from '@shared/components/scope-ui-snackbar/scope-ui-snackbar.component'
import { ScopeUiTableComponent } from '@shared/components/ui-components/scope-ui-table/scope-ui-table.component'
import { SharedModule } from '@shared/shared.module'
import { ScopeApprovalFlowComponent } from './approval-flow/scope-approval-flow/scope-approval-flow.component'
import { ScopeActivityComponent } from './components/scope-activity/scope-activity.component'
import { ScopeBreakdownComponent } from './components/scope-breakdown/scope-breakdown.component'
import { ScopeOutputComponent } from './components/scope-output/scope-output.component'
import { ScopeOverviewHeaderComponent } from './components/scope-overview/scope-overview-header/scope-overview-header.component'
import { DuplicateScopeTemplateComponent } from './components/scope-tab/duplicate-scope-template/duplicate-scope-template.component'
import { ScopeOverviewNgrxModule } from './scoping-overview-ngrx.module'
import { ExportDocumentService } from './service/export-document.service'
import { ChangeRequestModule } from './change-request/change-request.module'
import { ScopeOverviewRoutingModule } from './scope-overview.routing.module'

@NgModule({
  declarations: [DeliverableBuilderComponent, DuplicateScopeTemplateComponent],
  imports: [
    CommonModule,
    SharedModule,
    ScopeOverviewNgrxModule,
    ScopeActivityComponent,
    ScopeOverviewRoutingModule,
    ChangeRequestModule,
    ScopeUiAutocompleteComponent,
    ScopeApprovalFlowComponent,
    FindReplaceComponent,
    ScopeUiOptionsMenuComponent,
    TeamComponent,
    ScopeBreakdownComponent,
    ScopeOutputComponent,
    OutputEditorComponent,
    CKEditorModule,
    MatDividerModule,
    ScopeUiTableComponent,
    MatTooltipModule,
    ScopeUiSnackbarComponent,
    ScopeOverviewHeaderComponent,
    DetailsOverviewComponent,
  ],
  providers: [ExportDocumentService],
})
export class ScopeOverviewModule {}
